import { isEmpty } from 'src/views/utils/helper'

export const validateAsset = (content) => {
  console.log('content', content)
  if (content.asset_type.trim().length === 0) {
    return false
  }
  if (content.asset_type === 'VIDEO' && content.video_type.trim().length === 0) {
    return false
  }
  return !(content.asset_type === 'AUDIO' && !content.audio_type.trim().length === 0)
}

export const validateUpload = (content) => {
  if (content.video_type === 'MPVP') {
    return true
  }
  if (content.video_type === 'PLAYLIST') {
    if (
      content?.playlist_data?.playlist_type === 'MANUAL' &&
      isEmpty(content?.playlist_data?.content_data)
    ) {
      return false
    }
    return true
  }
  if (content.video_type === 'LIVE' && !content.stream) {
    return false
  }
  if (content.video_type === 'IPTV') {
    if (content.iptv_content_type === 'LIVE' && !content.stream) {
      return false
    } else if (
      content.iptv_content_type !== 'LIVE' &&
      content.source_asset_id.trim().length === 0
    ) {
      return false
    }
    return true
  }
  return !(content.video_type !== 'LIVE' && content.source_asset_id.trim().length === 0)
}

export const validateContentDetails = (content) => {
  if (content.title.trim().length === 0) {
    return false
  }
  // if (content.description.trim().length === 0) {
  //   return false
  // }

  if (isEmpty(content.thumbnail) || !content.thumbnail.website) {
    return false
  }
  if (isEmpty(content.category)) {
    return false
  }
  return !(isEmpty(content.poster) || !content.poster.website)
}

export const validateAdvanceSetting = (content) => {
  return !(content.is_geo_block_enabled && content.geo_block_countries.length === 0)
}

// export const validatePricing = (content) => {
//   if (content.is_restricted && isEmpty(content.pricing_model)) {
//     return false
//   }
//   return !(content.pricing_model.includes('SUBSCRIPTION') && isEmpty(content.active_subscription))
// }
export const validateContents = (data) => {
  return !!(
    (
      validateAsset(data) &&
      validateUpload(data) &&
      validateContentDetails(data) &&
      validateAdvanceSetting(data)
    )
    // validatePricing(data)
  )
}
